@if (!skeletonView) {
  <app-date [date]="order.createdAt"
    [tooltip]="'ORDERS.COMMON.DATES.created_at_tooltip' | translate"
    icon="create">
  </app-date>
  @if (order.logistic?.createdAt) {
    <app-date
      [date]="order.logistic.createdAt"
      [tooltip]="'ORDERS.COMMON.DATES.exported_at_tooltip' | translate"
      icon="local_shipping">
    </app-date>
  }
  <app-date [date]="order.updatedAt"
    [tooltip]="'ORDERS.COMMON.DATES.updated_at_tooltip' | translate"
    icon="update">
  </app-date>
  @if (order.returnedAt) {
    <app-date
      [date]="order.returnedAt"
      [tooltip]="'ORDERS.COMMON.DATES.returned_at_tooltip' | translate"
      icon="highlight_off">
    </app-date>
  }
  @if (order.boughtOutAt) {
    <app-date
      [date]="order.boughtOutAt"
      [tooltip]="'ORDERS.COMMON.DATES.bought_out_at_tooltip' | translate"
      icon="attach_money">
    </app-date>
  }
} @else {
  <ngx-skeleton-loader [count]="2" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
  @if (order.logistic?.createdAt) {
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
  }
  @if (order.returnedAt) {
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
  }
  @if (order.boughtOutAt) {
    <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px' }"></ngx-skeleton-loader>
  }
}
